import camila from '../../../img/team/thumbnail/camila.png';
import bruno from '../../../img/team/thumbnail/bruno.png';
import vania from '../../../img/team/thumbnail/andrea.png';
import anahi from '../../../img/team/thumbnail/anahi.png';
import claudia from '../../../img/team/thumbnail/claudia.png';
import fernando from '../../../img/team/thumbnail/fernando.png';
import gabriel from '../../../img/team/thumbnail/gabriel.png';
import karin from '../../../img/team/thumbnail/karin.png';
import karla from '../../../img/team/thumbnail/karla.png';
import paola from '../../../img/team/thumbnail/paola.png';


export default [
    {
        id: 1,
        fullName: 'Camila Barrientos',
        instrument: 'clarinet',
        title: 'co-founderF',
        thumbnail: camila,
        bio: 'camilabio',
        quote: 'camilaquote',
    },
    {
        id: 2,
        fullName: 'Bruno Lourensetto',
        instrument: 'trumpet',
        title: 'co-founderM',
        thumbnail: bruno,
        bio: 'brunobio',
        quote: 'brunoquote',
    },
    {
        id: 3,
        fullName: 'Andrea García',
        instrument: 'cello',
        title: 'finance director',
        thumbnail: vania,
        bio: 'vaniabio',
        quote: 'vaniaquote',
    },
    {
        id: 4,
        fullName: 'Anahí Garvizu',
        instrument: 'cello',
        title: 'press and communications',
        thumbnail: anahi,
        bio: 'anahibio',
        quote: 'anahiquote',
    },
    {
        id: 5,
        fullName: 'Claudia Machicado',
        instrument: 'bass',
        title: 'artistic production',
        thumbnail: claudia,
        bio: 'claudiabio',
        quote: 'claudiaquote',
    },
    {
        id: 6,
        fullName: 'Fernando López',
        instrument: 'piano',
        title: 'media support',
        thumbnail: fernando,
        bio: 'fernandobio',
        quote: 'fernandoquote',
    },
    {
        id: 7,
        fullName: 'Gabriel Bilbao',
        instrument: 'violin',
        title: 'support',
        thumbnail: gabriel,
        bio: 'gabrielbio',
        quote: 'gabrielquote',
    },
    {
        id: 8,
        fullName: 'Karin Cuellar',
        instrument: 'violin',
        title: 'inst. coordinator',
        thumbnail: karin,
        bio: 'karinbio',
        quote: 'karinquote',
    },
    {
        id: 9,
        fullName: 'Karla Jiménez',
        instrument: 'clarinet',
        title: 'mpr coordinator',
        thumbnail: karla,
        bio: 'karlabio',
        quote: 'karlaquote',
    },
    {
        id: 10,
        fullName: 'Paola Machicado',
        instrument: 'percusion',
        title: 'artistic production',
        thumbnail: paola,
        bio: 'paolabio',
        quote: 'paolaquote',
    },
]
